export enum BatteryStatus {
  OK = 'OK',
  ALERTED = 'ALERTED',
  WARNED = 'WARNED',
  INACTIVE = 'INACTIVE',
  UNKNOWN = 'UNKNOWN'
}
